export const Slider = ({ step }) => {
  const GREY = "#4C4E51";
  const IMAX_BLUE = "#418BFA";
  return (
    <svg
      width="184"
      height="12"
      viewBox="0 0 184 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0"
        y="5"
        width="92"
        height="3"
        rx="1.5"
        fill={step > 0 ? IMAX_BLUE : GREY}
      />
      <rect
        x="92"
        y="5"
        width="92"
        height="3"
        rx="1.5"
        fill={step > 1 ? IMAX_BLUE : GREY}
      />
      <circle cx="6" cy="6" r="6" fill={IMAX_BLUE} />
      <circle cx="94" cy="6" r="6" fill={step >= 1 ? IMAX_BLUE : GREY} />
      <circle cx="178" cy="6" r="6" fill={step >= 2 ? IMAX_BLUE : GREY} />
    </svg>
  );
};
